<template>
	<div class="tabs">
		<!--closable这里说明home是不能关闭的-->
		<el-row style="overflow: hidden;">
			<el-col :span="22" style="overflow: hidden;">
				<el-scrollbar style="height: 90%;width:100%;white-space: pre;">
					<el-tag
						:key="index"
						size="small"
						v-for="(tag, index) in tags"
						:closable="tag.name !== 'home'"
						:disable-transitions="false"
						@close="handleClose(tag, index)"
						@click="changeMenu(tag)"
						:effect="$route.path === tag.path ? 'dark' : 'plain'"
					>
						{{ tag.label }}
					</el-tag>
				</el-scrollbar>
			</el-col>
			<el-col :span="2" style="text-align: right;">
				<el-dropdown trigger="click">
					<span class="el-tag el-tag--small el-tag--dark"> 编辑
						<i class="el-icon-arrow-down el-icon--right"></i></span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item icon="el-icon-circle-close" @click.native="colose">关闭所有</el-dropdown-item>
						<el-dropdown-item icon="el-icon-close" @click.native="colose1">关闭</el-dropdown-item>
						<el-dropdown-item icon="el-icon-close" @click.native="colose2">关闭其他</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
	computed: {
		...mapState({
			tags: state => state.tab.tabsList
		})
	},
	created() {
		let st = this.$store;
		//this.tags = sessionStorage.getItem('tabsList');
		let tabl = sessionStorage.getItem('tabsList');
	},
	methods: {
		...mapMutations({
			close: 'closeTab'
		}),
		//关闭标签
		handleClose(tag, index) {
			let length = this.tags.length - 1;
			//vuex调方法的另一种写法
			this.close(tag);
			// 如果关闭的标签不是当前路由的话，就不跳转
			if (tag.name !== this.$route.name) {
				return;
			}
			// 关闭的标签是最右边的话，往左边跳转一个
			if (index === length) {
				this.$router.push({ name: this.tags[index - 1].name });
			} else {
				// 否则往右边跳转
				this.$router.push({ name: this.tags[index].name });
			}
		},
		//选择标签跳转路由
		changeMenu(item) {
			this.$router.push({path:item.path});
			this.$store.commit('selectMenu', item);
		},
		colose(command) {
			let that = this;
			that.tags.forEach(function(it, ind) {
				if (it.path != '/') {
					that.close(it);
				}
			});
		},
		colose1(command) {
			let that = this;
			that.tags.forEach(function(it, ind) {
				if (it.name != 'home'){
					if (it.name == that.$route.name) {
						that.close(it);
						that.$router.push({ name: that.tags[ind - 1].name });
					}
				}
			});
		},
		colose2(command) {
			let that = this;
			that.tags.forEach(function(it, ind) {
				if ((it.name != that.$route.name) && (it.name != 'home')) {
					that.close(it);
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.tabs {
    overflow-y: hidden;
    background: #fff;
    display: inline-block;
    line-height: 50px;
    min-height: 50px;
    margin: 0 20px;
	padding:0 20px;
	.el-tag {
		margin-right: 10px;
		cursor: pointer;
	}
	.el-breadcrumb__inner{
		color:#fff;
	}
}
</style>
